import React, { useEffect, useRef, useState } from "react";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import AddUniversityMonitoringRequest from "./AddUniversityMonitoringRequest";
import EducationalMonitoringCollapse from "./UniversityMonitoringCollapse";
import { Col, ConfigProvider, Row } from "antd";
import ar_EG from "antd/lib/locale/ar_EG";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import { AppDispatch, RootState } from "../../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import { getDateRange, scroll } from "../../../../components/utils/utils";
import {
  getUniversitiesMonitoring,
  getUniversities,
  getAcademicLevels,
} from "../../../../apis/actions/monitoring.actions";
import { getBeneficiaryDetails } from "../../../../apis/actions/recipient.actions";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
const UniversityMonitoringRequest = ({
  selectedFilter,
  filterOrphans,
  state,
}: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { data: monitorings, loading } = useSelector(
    (state: RootState) => state?.monitoring.universityMonitorings
  );

  const { universities, TotalUniversityMonitorings } = useSelector(
    (state: RootState) => state?.monitoring
  );
  const { data: academicLevels } = useSelector(
    (state: RootState) => state?.monitoring.academicLevels
  );
  useEffect(() => {
    dispatch(getBeneficiaryDetails());
    dispatch(getAcademicLevels());
    dispatch(getUniversities());
  }, [dispatch]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedFilter, state]);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      getUniversitiesMonitoring({
        limit: itemPerPage,
        page: currentPage,
        date_from: date_from,
        date_to: date_to,
        partner_id: selectedFilter,
      })
    );
  }, [dispatch, currentPage, selectedFilter, state]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  return (
    <>
      <ConfigProvider locale={ar_EG} direction="rtl">
        <Row gutter={8} style={{ marginBottom: "3rem" }}>
          <Col
            xxl={5}
            xl={5}
            lg={5}
            md={5}
            sm={24}
            xs={24}
            style={{ paddingTop: "0.5rem" }}
          >
            <PrimaryButton
              onClick={() => setIsModalVisible(true)}
              title="طلب متابعة تعليمية"
              className="takaful--add-request-btn"
            />
          </Col>
        </Row>
      </ConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      // eslint-disable-next-line eqeqeq
      ) : monitorings?.length === 0 && !selectedFilter && state.year == "" ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات
        </p>
      ) : monitorings?.length === 0 && (selectedFilter || state.year !== "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <EducationalMonitoringCollapse requests={monitorings} />
          </Row>
          <div className="takaful--pagination-container">
            {monitorings &&
              Math.ceil(TotalUniversityMonitorings) * itemPerPage >
                itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalUniversityMonitorings) * itemPerPage}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
      <AddUniversityMonitoringRequest
        beneficiary={filterOrphans}
        isModalVisible={isModalVisible}
        academicLevels={academicLevels}
        universities={universities}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  );
};

export default UniversityMonitoringRequest;
